export const MODALS = {
  accentInfo: "accentInfo",
  acceptableUsePolicy: "acceptableUsePolicy",
  audioSettingsIntro: "audioSettingsIntro",
  customVoice: "customVoice",
  deleteAccount: "deleteAccount",
  deleteCalibration: "deleteCalibration",
  deleteConversion: "deleteConversion",
  deleteFolder: "deleteFolder",
  deleteProject: "deleteProject",
  deleteRecording: "deleteRecording",
  disabledMicrophone: "disabledMicrophone",
  errorInfo: "errorInfo",
  getHelp: "getHelp",
  howToRequestKidsVoices: "howToRequestKidsVoices",
  information: "information",
  projectInfo: "projectInfo",
  projectsFilters: "projectsFilters",
  provideFeedback: "provideFeedback",
  recordingInfo: "recordingInfo",
  recordingTts: "recordingTts",
  regenerationIntro: "regenerationIntro",
  regenerationSettings: "regenerationSettings",
  renameCalibration: "renameCalibration",
  renameConversion: "renameConversion",
  renameFolder: "renameFolder",
  renameProject: "renameProject",
  renameRecording: "renameRecording",
  reportConversionIssue: "reportConversionIssue",
  skipWelcomeWizard: "skipWelcomeWizard",
  trialWarning: "trialWarning",
  ttsLanguageTooltip: "ttsLanguageTooltip",
  ttsRequestsLimit: "ttsRequestsLimit",
  userProfession: "userProfession",
  upgradePlan: "UpgradePlan",
  voicesFilters: "voicesFilters",
  voiceUpgradePlan: "VoiceUpgradePlan",
  welcomeProfession: "welcomeProfession",
  whatIsAccent: "whatIsAccent",
  whatIsAutoCalibration: "whatIsAutoCalibration",
  whatIsCalibration: "whatIsCalibration",
  whatIsNarrationStyle: "whatIsNarrationStyle",
  whatIsPitch: "whatIsPitch",
  voiceSettings: "voiceSettings",
};

export const UPGRADE_PLAN_PLACE = {
  download: "download",
  trial_expired: "trial_expired",
  out_of_minutes: "out_of_minutes",
  out_of_credits: "out_of_credits",
  out_of_characters: "out_of_characters",
  voice: "voice",
  accent: "accent",
  unlock_sts: "unlock_sts",
};
